import * as React from "react";
import { GvcCreateForm } from "./form";

export const GvcCreateInitializer: React.FC = () => {
  return <GvcCreateForm />;
};
